module.exports = __webpack_public_path__ + "img/markortech-bg.7e341b94.svg";